import {
  APPLICATION_CREATED,
  APPLICATION_FETCHED,
  APPLICATION_UPDATED,
  APPLICATION_REWOUND,
  APPLICATION_UPDATE_REQUESTED
} from 'utils/constants';
import { OAUTH_SIGN_IN_START } from 'actions/oauth-sign-in';
import { setApplicationNumber } from 'actions/applications';

export default (state = null, action) => {
  let application;
  switch (action.type) {
    case APPLICATION_CREATED:
      application = action.data.application;
      setApplicationNumber(application.number)
      return { ...application };
    case APPLICATION_FETCHED:
      application = action.data.application;
      setApplicationNumber(application.number)
      return { ...application };
    case APPLICATION_UPDATED:
      application = action.data.application;
      setApplicationNumber(application.number);
      return { ...application };
    case APPLICATION_UPDATE_REQUESTED:
      application = action.data.application;
      return { ...application, updating: true };
    case APPLICATION_REWOUND:
      application = action.data.application;
      setApplicationNumber(application.number)
      return { ...application };
    case OAUTH_SIGN_IN_START:
      return {}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/application.js